export enum BookingStep {
  Users = 1,
  BookingDetail = 2,
  Confirmation = 3,
}


// Salon
export const UPDATE_SALON_SERVICES = 'SALON/UPDATE_SERVICES';
export const UPDATE_SALON_INFORMATION = 'SALON/UPDATE_INFORMATION';
export const UPDATE_BOOKING_SETTINGS = 'SALON/UPDATE_BOOKING_SETTINGS';


// Booking
export const FETCH_CURRENT_BOOKING = 'BOOKING/FETCH_CURRENT_BOOKING';
export const UPDATE_BOOKING_STEP = 'BOOKING/UPDATE_STEP';
export const UPDATE_NEW_USER_FLAG = 'BOOKING/UPDATE_NEW_USER_FLAG';
export const UPDATE_ACTIVE_USER = 'BOOKING/UPDATE_ACTIVE_USER';
export const UPDATE_BOOKING_USERS = 'BOOKING/UPDATE_USERS';
export const UPDATE_BOOKING_SUGGESTED_USERS = 'BOOKING/BOOKING_SUGGESTED_USERS';

export const UPDATE_ACTIVE_ROOT_CATE = 'BOOKING/UPDATE_ACTIVE_ROOT_CATE';
export const UPDATE_ACTIVE_SUB_CATE = 'BOOKING/UPDATE_ACTIVE_SUB_CATE';
export const UPDATE_ACTIVE_ROOT_CATE_MOBILE = 'BOOKING/UPDATE_ACTIVE_ROOT_CATE_MOBILE';

export const UPDATE_STYLIST_MAPPINGS = 'BOOKING/UPDATE_STYLIST_MAPPINGS';
export const UPDATE_AVAILABLE_STYLISTS = 'BOOKING/UPDATE_AVAILABLE_STYLISTS';
export const UPDATE_STYLIST_SETTINGS = 'BOOKING/UPDATE_STYLIST_SETTINGS';
export const UPDATE_STYLIST_AVAILABLE_TIMES = 'BOOKING/UPDATE_STYLIST_AVAILABLE_TIMES';

export const UPDATE_BOOKING_NOTES = 'BOOKING/UPDATE_NOTES';
export const UPDATE_BOOKING_CREDIT_CARD = 'BOOKING/UPDATE_CREDIT_CARD';
export const UPDATE_BOOKING_HISTORY = 'BOOKING/UPDATE_BOOKING_HISTORY';

